import { Modal, ModalProps, Toggle } from '@design';
import React from 'react';

import styles from './TogglesModal.module.scss';

export interface ToggleItem {
  label: string;
  id: string;
}

export interface TogglesModalProps extends Partial<ModalProps> {
  items: ToggleItem[];
  title: ModalProps['title'];
  checkedItems: ToggleItem['id'][];
  onClose: () => void;
  onChange: (item: ToggleItem, checked: boolean) => void;
}

export const TogglesModal = ({
  title,
  items,
  checkedItems,
  onClose,
  onChange,
  ...rest
}: TogglesModalProps) => {
  return (
    <Modal
      className={styles.styledModal}
      isOpen
      title={title}
      onClose={onClose}
      {...rest}
    >
      <div className={styles.container}>
        {items.map(item => (
          <div className={styles.row} key={item.id}>
            <span>{item.label}</span>
            <Toggle
              size="medium"
              isChecked={checkedItems.includes(item.id)}
              onToggle={checked => onChange(item, checked)}
            />
          </div>
        ))}
      </div>
    </Modal>
  );
};
